var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graduation"},[(_vm.showSwiper)?_c('GradCarousel'):_vm._e(),_c('div',{staticClass:"graduation__child"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }